import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  assetBasePath:
    'https://energy-cockpit-staging.viessmann-climatesolutions.com/assets/',
  energyCockpitConfig: {
    baseUrl: 'https://api-staging.viessmann-climatesolutions.com',
    translationsBaseUrl:
      'https://api-staging.viessmann-climatesolutions.com/translations/v2/',
  },
};
